import UsersAndCohorts from "./UsersAndCohorts";

export { UsersAndCohortsList } from "./UsersAndCohorts";
export default UsersAndCohorts;
